module.exports = __webpack_public_path__ + "img/prizeTwo.9fb8a4bc.png";